import { render, staticRenderFns } from "./ResidualRiskModal.vue?vue&type=template&id=a5989f7a&"
import script from "./ResidualRiskModal.vue?vue&type=script&lang=js&"
export * from "./ResidualRiskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports